/*
    Based on David Walsh's module: http://davidwalsh.name/pubsub-javascript
*/
"use strict";

var stations = {};

module.exports = {
    
    /*
        Listen to a station
        
        @param [string]: Name of the station
        @param [function]: Function to run on broadcast
        @return [object]: New Listener object with remove method
    */
    listen: function (name, callback) {
        var listenerIndex = 0;
        
        // Create station if not yet created
        stations[name] = stations[name] || [];
        
        // Add callback
        listenerIndex = stations[name].push(callback) - 1;
        
        return {
            // Remove Listener
            remove: function () {
                delete stations[name][listenerIndex];
            }
        };
    },
    
    /*
        Broadcast to a station
        
        @param [string]: Name of the station
        @param [any]: Data to pass on
    */
    broadcast: function (name, data) {
        if (stations.hasOwnProperty(name)) {
            data = (data != undefined) ? data : {};

            stations[name].forEach(function (callback) {
                callback(data);
            });
        }
        
        return this;
    },
    
    /*
        Create a broadcast function
        
            Shorthand for .broadcast ie 
                var broadcaster = wavestation.newBroadcast('foo/bar');
                broadcaster('yourData');
                
        @param [string]: Name of station
        @param 
    */
    newBroadcast: function (name) {
        var self = this;

        return function (data) {
            self.broadcast(name, data);
        }
    }
    
};